// extracted by mini-css-extract-plugin
module.exports = {"ok-button":"OkButton-OkButton-ok-button--H3A0hrn","okButton":"OkButton-OkButton-ok-button--H3A0hrn","active":"OkButton-OkButton-active-11g485TP"};